export enum SearchType {
    ACC_NO = 1,
    SLRN = 2,
    METER_NO = 3,
    BUILDING_OWNER = 4,
    PHONE_NUMBER = 5,
    EMAIL = 6,
    ADDRESS = 7,
    SERIAL_NO = 8,
    SEAL_NO = 9,
    ITINERARY = 10,
    CONTRACT_NO = 11
}